import _ from 'lodash';

const getCitationKey = citation => citation?.citationId ?? citation?.id ?? null;

const mergeCitations = (existing, incoming) => {
  const incomingWithKeys = (incoming ?? []).filter(citation => !_.isNil(getCitationKey(citation)));

  if (!incomingWithKeys.length) {
    return existing;
  }

  const existingByKey = (existing ?? []).reduce((acc, citation) => {
    const key = getCitationKey(citation);

    if (_.isNil(key)) {
      return acc;
    }

    return { ...acc, [key]: citation };
  }, {});

  const mergedByKey = incomingWithKeys.reduce((acc, citation) => {
    const key = getCitationKey(citation);
    const prior = acc[key];

    return {
      ...acc,
      [key]: prior ? { ...prior, ...citation } : citation,
    };
  }, existingByKey);

  const incomingOrderKeys = incomingWithKeys.map(getCitationKey);
  const existingOrderKeys = (existing ?? []).map(getCitationKey).filter(key => !_.isNil(key));
  const orderedKeys = [...existingOrderKeys];

  incomingOrderKeys.forEach(key => {
    if (!orderedKeys.includes(key)) {
      orderedKeys.push(key);
    }
  });

  return orderedKeys.map(key => mergedByKey[key]);
};

export const applyCitationsForMessage = (citations, payload) => {
  if (_.isNil(payload?.messageId)) {
    return citations;
  }

  const existingForMessage = citations[payload.messageId] ?? [];
  const mergedForMessage = mergeCitations(existingForMessage, payload.citations);

  if (mergedForMessage === existingForMessage) {
    return citations;
  }

  return {
    ...citations,
    [payload.messageId]: mergedForMessage,
  };
};
